import { Key as ReactKey, ReactNode, CSSProperties, Suspense, lazy } from 'react';
import { LazyLoadingAnimation } from "../Lazy";
import { ErrorCatch } from '@Primitive/ErrorCatch';
import { isDefined, isString } from '@Utils/Micro';

const MarkdownBase = lazy(() => import("./Markdown"));
// ================================================================================================
export interface MarkdownProps {
    children?: string | string[] | ReactNode;
    key?: ReactKey;
    source?: string;
    style?: CSSProperties;
    className?: string;
    width?: number;
    height?: number;
    padding?: number;
    tocWidth?: number;
    tocWidthThreshold?: number;
    tocStyle?: CSSProperties;
    anchorOptions?: { permalink: boolean; };
    /**
     * If enabled, all clicks to <a> will not update window.location.hash.
     * Note: This flag does not affect anchor tags that its target is "_blank"
     * WARNING: we don't implement the change of this prop. Implement it if we need it :P.
     */
    deferAnchorClick?: boolean;

    /**
     * Used only if `deferAnchorClick` is enabled. Triggered on anchor click.
     */
    onAnchorClick?: (href: string) => void;

    // show markdown editor
    editMode?: boolean;
    onSaveClick?: (md: string) => void;
}
// ================================================================================================
export const Markdown = (props: MarkdownProps) => {
    return <ErrorCatch>
        <Suspense fallback={<LazyLoadingAnimation />}>
            <MarkdownBase {...props} />
        </Suspense>
    </ErrorCatch>
}
// ------------------------------------------------------------------------------------------------
/**
 * Common function for rendering widget's description. Used from playground too.
 */
export function helperRenderMarkdown(
    value: ReactNode,
    markdownProps: MarkdownProps = {}
) {
    const finalProps: MarkdownProps = {
        key: 'markdown',
        className: 'widget-doc',
        anchorOptions: {
            permalink: false,
        },
        deferAnchorClick: true,
        tocWidth: 280,
        ...markdownProps
    };
    const { tocWidth } = finalProps;

    // if toc is not used; remove toc 'keyword'
    if (!isDefined(tocWidth) || tocWidth == 0) {
        if (isString(value)) {
            value = (value as string).replace("${toc}", "").replace("# toc", "");
        }
    }

    return <Markdown
        {...finalProps}
    >
        {value}
    </Markdown>;
}
// ================================================================================================